import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {
    baseUrl = `${baseUrl}/atendimento`

    return {
        create(filaId, agendamentoId = null) {
            return agendamentoId
                ? repository.get(`${baseUrl}/create/${filaId}/${agendamentoId}`)
                : repository.get(`${baseUrl}/create/${filaId}`)
        },
        store(params) {
            return repository.post(`${baseUrl}`, params)
        },
        uploadImagem(params) {
            return repository.post(`${baseUrl}/upload-imagem`, params)
        },
        storeFeridaProcedimento(params) {
            return repository.post(`${baseUrl}/ferida-procedimento`, params)
        },
        validarProcedimentosCbo(params) {
            return repository.post(`${baseUrl}/validar-procedimentos-cbo`, params)
        },
        destroyFeridaProcedimento(id) {
            return repository.delete(`${baseUrl}/ferida-procedimento/${id}`)
        },
        destroy(id) {

            return repository.delete(`${baseUrl}/${id}/destroy`)
        },
        list(queryParms) {
            return repository.get(`${baseUrl}/list?${urlUtil.serialize(queryParms)}`)
        },
        getHistoricoPreAtendimento(id) {
            return repository.get(`${baseUrl}/historico-pre-atendimento/${id}`)
        },
        getHistoricoAtendimentoSoap(id) {
            return repository.get(`${baseUrl}/historico-atendimento-soap/${id}`)
        },
        getHistoricoAtendimentoHospital(id) {
            return repository.get(`${baseUrl}/historico-atendimento-hospital/${id}`)
        },
        getHistoricoPosConsulta(id) {
            return repository.get(`${baseUrl}/historico-pos-consulta/${id}`)
        },
        getHistoricoProntoAtendimentoAtendimento(id) {
            return repository.get(`${baseUrl}/historico-pronto-atendimento-atendimento/${id}`)
        },
        getUrlHistoricoConectaSUSV1(prontuario) {
            return repository.get(`${baseUrl}/url-historico-conectasusv1/${prontuario}`)
        },
        exameDentroPrazoValidade(queryParms) {
            return repository.get(`${baseUrl}/exame-dentro-prazo-validade?${urlUtil.serialize(queryParms)}`)
        },
        encaminhamentoPendente(queryParms) {
            return repository.get(`${baseUrl}/encaminhamento-pendente?${urlUtil.serialize(queryParms)}`)
        },
        prescricaoMedicamento(queryParms) {
            return repository.get(`${baseUrl}/prescricao-medicamento?${urlUtil.serialize(queryParms)}`)
        },
        storeAtendimentoAssinado: (id, params) => {
            return repository.post(`${baseUrl}/${id}/store-atendimento-assinado`, params)
        },
        getOci(id) {
            return repository.get(`${baseUrl}/oci/${id}`)
        },
    }
}